import * as React from "react";

const lightGreen = "#6EEDB8";

interface IconSizeProps {
    height?: number;
    width?: number;
}

export const IconCaretDown: React.SFC = () => (
    <svg width="9" height="6" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.833.857A.582.582 0 0 1 9 1.273c0 .16-.056.298-.167.415L4.896 5.825A.528.528 0 0 1 4.5 6a.528.528 0 0 1-.396-.175L.167 1.688A.582.582 0 0 1 0 1.273c0-.16.056-.299.167-.416A.528.528 0 0 1 .563.682h7.875c.152 0 .284.058.395.175z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export const IconChat: React.SFC = () => (
    <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17 13V1H1v12h4v3h2l2-3z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
        />
    </svg>
);

export const IconCheck: React.SFC<IconSizeProps> = props => {
    const height = props.height || 14;
    const width = props.width || 14;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 10"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke={lightGreen}
                d="M0 5l3.984 3.897L12 1"
                strokeWidth="2"
                fill="none"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const IconChevronDown: React.SFC = () => (
    <svg
        width="14"
        height="10"
        viewBox="0 0 17 10"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 1.597L8.451 8.5l7.049-7"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
        />
    </svg>
);

export const IconChevronLeft: React.SFC = () => (
    <svg width="10" height="16" xmlns="http://www.w3.org/2000/svg">
        <path
            stroke="currentColor"
            strokeWidth="2"
            d="M8.903 1L2 7.951 9 15"
            fill="none"
            fillRule="evenodd"
        />
    </svg>
);

export const IconChevronRight: React.SFC = () => (
    <svg width="10" height="16" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.097 15L8 8.049 1 1"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
        />
    </svg>
);

export const IconChevronUp: React.SFC = () => (
    <svg
        width="14"
        height="10"
        viewBox="0 0 17 10"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.5 7.403L7.549.5.5 7.5"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
        />
    </svg>
);

export const IconClose: React.SFC<IconSizeProps> = props => {
    const width = props.width || 14;
    const height = props.height || 14;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                fill="none"
                fillRule="evenodd"
                strokeLinecap="square"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M1 1l22.164 22.164L1 1zM23.164 1L1 23.164 23.164 1z" />
            </g>
        </svg>
    );
};

export const IconDrawerToggle = () => (
    <svg
        width="30"
        height="24"
        viewBox="0 0 30 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="currentColor" fillRule="evenodd">
            <rect width="30" height="4" rx="2" />
            <rect y="10" width="30" height="4" rx="2" />
            <rect y="20" width="30" height="4" rx="2" />
        </g>
    </svg>
);

export const IconEmail: React.SFC<{ style?: any }> = props => (
    <svg
        width="28"
        height="18"
        viewBox="0 0 22 18"
        xmlns="http://www.w3.org/2000/svg"
        style={props.style}
    >
        <g stroke="#3F30A3" fill="none" fillRule="evenodd">
            <path
                d="M20.048 16.714H1.952A.955.955 0 0 1 1 15.762V1.952C1 1.43 1.429 1 1.952 1h18.096c.523 0 .952.429.952.952v13.81a.955.955 0 0 1-.952.952z"
                strokeLinejoin="round"
            />
            <path d="M1 1l9 8.571c.571.524 1.429.524 1.952 0L21 1M1 16.714l8.571-7.619M21 16.714l-8.571-7.619" />
        </g>
    </svg>
);

export const IconEnvelope: React.SFC = () => (
    <svg
        width="29"
        height="23"
        viewBox="0 0 29 23"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd">
            <path
                d="M26.714 22H2.286C1.58 22 1 21.427 1 20.727V2.273C1 1.573 1.58 1 2.286 1h24.428C27.42 1 28 1.573 28 2.273v18.454c0 .7-.58 1.273-1.286 1.273z"
                strokeLinejoin="round"
            />
            <path d="M1 1l12.15 11.474c.77.7 1.93.7 2.636 0L28 1M1 22l11-10M28 22L17 12" />
        </g>
    </svg>
);

export const IconFeedback: React.SFC = () => (
    <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="currentColor"
            strokeWidth="0.5"
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M2.37561 8.25381C2.37561 4.45705 5.45017 1.37561 9.24694 1.37561C13.0506 1.37561 16.132 4.45705 16.132 8.25381C16.132 12.0506 13.0506 15.132 9.24694 15.132C5.45017 15.132 2.37561 12.0506 2.37561 8.25381ZM3.75125 8.25381C3.75125 11.294 6.21365 13.7564 9.25381 13.7564C12.294 13.7564 14.7564 11.294 14.7564 8.25381C14.7564 5.21365 12.294 2.75125 9.25381 2.75125C6.21365 2.75125 3.75125 5.21365 3.75125 8.25381ZM12.7755 9.62946C12.2252 11.0395 10.8564 12.0368 9.25381 12.0368C7.65119 12.0368 6.28243 11.0395 5.73217 9.62946H6.88083C7.36231 10.448 8.23584 11.0051 9.25381 11.0051C10.2718 11.0051 11.1522 10.448 11.6268 9.62946H12.7755ZM6.84644 7.56599C7.41625 7.56599 7.87817 7.10407 7.87817 6.53426C7.87817 5.96445 7.41625 5.50253 6.84644 5.50253C6.27663 5.50253 5.81471 5.96445 5.81471 6.53426C5.81471 7.10407 6.27663 7.56599 6.84644 7.56599ZM11.6612 7.56599C12.231 7.56599 12.6929 7.10407 12.6929 6.53426C12.6929 5.96445 12.231 5.50253 11.6612 5.50253C11.0914 5.50253 10.6295 5.96445 10.6295 6.53426C10.6295 7.10407 11.0914 7.56599 11.6612 7.56599Z" />
            <path d="M12.6372 20.7461C12.6372 16.9494 15.7118 13.8679 19.5085 13.8679C23.3122 13.8679 26.3936 16.9494 26.3936 20.7461C26.3936 24.5429 23.3122 27.6243 19.5085 27.6243C15.7118 27.6243 12.6372 24.5429 12.6372 20.7461ZM14.0128 20.7461C14.0128 23.7863 16.4752 26.2487 19.5154 26.2487C22.5556 26.2487 25.018 23.7863 25.018 20.7461C25.018 17.706 22.5556 15.2436 19.5154 15.2436C16.4752 15.2436 14.0128 17.706 14.0128 20.7461ZM15.9938 24.5291C16.544 23.1191 17.9128 22.1218 19.5154 22.1218C21.118 22.1218 22.4868 23.1191 23.0371 24.5291H21.8884C21.4069 23.7106 20.5334 23.1535 19.5154 23.1535C18.4974 23.1535 17.617 23.7106 17.1424 24.5291H15.9938ZM17.108 20.0583C17.6778 20.0583 18.1398 19.5964 18.1398 19.0266C18.1398 18.4568 17.6778 17.9948 17.108 17.9948C16.5382 17.9948 16.0763 18.4568 16.0763 19.0266C16.0763 19.5964 16.5382 20.0583 17.108 20.0583ZM21.9228 20.0583C22.4926 20.0583 22.9545 19.5964 22.9545 19.0266C22.9545 18.4568 22.4926 17.9948 21.9228 17.9948C21.353 17.9948 20.8911 18.4568 20.8911 19.0266C20.8911 19.5964 21.353 20.0583 21.9228 20.0583Z" />
        </g>
    </svg>
);

export const IconEyeOpen: React.SFC = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 25 18"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="#21006E" strokeWidth="2" fill="none" fillRule="evenodd">
            <path
                d="M9.9 1.24C11 1 11.293.998 12 1c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
                strokeLinecap="square"
            />
            <g transform="translate(1 1)">
                <path
                    d="M16.94 13.94A10.07 10.07 0 0 1 11 16C4 16 0 8 0 8a18.45 18.45 0 0 1 5.06-5.94"
                    strokeLinejoin="round"
                />
                <circle cx="11" cy="8" r="3" />
            </g>
        </g>
    </svg>
);

export const IconEyeClosed = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 20"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="#21006E"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
            strokeLinejoin="round"
        >
            <path d="M17.94 15.94A10.07 10.07 0 0 1 12 18c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 2.24A9.12 9.12 0 0 1 12 2c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M3 1l18 18" />
        </g>
    </svg>
);

export const IconFacebook = () => (
    <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.91.857c.93 0 1.725.33 2.385.99.66.66.99 1.455.99 2.385v11.25c0 .93-.33 1.725-.99 2.385a3.25 3.25 0 0 1-2.384.99h-2.203v-6.973h2.332l.351-2.718h-2.683V7.43c0-.437.091-.765.275-.984.184-.219.541-.328 1.072-.328l1.43-.012V3.681c-.492-.07-1.188-.105-2.086-.105-1.063 0-1.912.312-2.549.937s-.955 1.508-.955 2.649v2.004H7.551v2.718h2.344v6.973H3.661a3.25 3.25 0 0 1-2.385-.99 3.25 3.25 0 0 1-.99-2.385V4.232c0-.93.33-1.724.99-2.385A3.25 3.25 0 0 1 3.66.857h11.25z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export const IconFileGeneric = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 37 45"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="currentColor"
            fill="none"
            fillRule="evenodd"
            strokeLinejoin="round"
        >
            <path d="M34.227 44H2.955A1.955 1.955 0 0 1 1 42.045V2.955C1 1.875 1.875 1 2.955 1h21.5l11.727 11.727v29.318c0 1.08-.875 1.955-1.955 1.955z" />
            <path d="M24.455 1.977v10.75h11.727" />
        </g>
    </svg>
);

export const IconFilePDF = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 37 45"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="currentColor"
            fill="none"
            fillRule="evenodd"
            strokeLinejoin="round"
        >
            <path d="M19.563 17.41c.304-3.853-3.853-4.059-2.927.198.947 4.35 5.914 13.453 10.75 15.636 4.375 1.975 4.642-3.963-8.264-3.963-11.893 0-12.503 10.01-7.127 5.918 5.682-4.326 7.268-13.987 7.568-17.79z" />
            <path d="M34.227 44H2.955A1.955 1.955 0 0 1 1 42.045V2.955C1 1.875 1.875 1 2.955 1h21.5l11.727 11.727v29.318c0 1.08-.875 1.955-1.955 1.955z" />
            <path d="M24.455 1.977v10.75h11.727" />
        </g>
    </svg>
);

export const IconFileWeb = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 36 38"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            transform="translate(1 1)"
            stroke="#3F30A3"
            fill="none"
            fillRule="evenodd"
            strokeLinejoin="round"
        >
            <path d="M4 4h27.2v17.6H4z" />
            <path
                d="M0 26.4V1.6A1.6 1.6 0 0 1 1.6 0H32a1.6 1.6 0 0 1 1.6 1.6v24.8A1.6 1.6 0 0 1 32 28H1.6A1.6 1.6 0 0 1 0 26.4zM24.4 36v-1.6a1.6 1.6 0 0 0-1.6-1.6h-.511a1.6 1.6 0 0 1-1.578-1.863L21.2 28h-8l.49 2.937A1.6 1.6 0 0 1 12.11 32.8H11.6a1.6 1.6 0 0 0-1.6 1.6V36h14.4z"
                strokeLinecap="square"
            />
            <circle strokeLinecap="round" cx="16.8" cy="24.8" r="1" />
        </g>
    </svg>
);

export const IconFileAudio: React.SFC = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
        >
            <path d="m29.192 14.808c5.0768 5.0768 5.0768 13.308 0 18.385" />
            <path d="m32.374 11.626c6.8342 6.8342 6.8342 17.915 0 24.749" />
            <path d="m35.556 8.4437c8.5915 8.5915 8.5915 22.521 0 31.113" />
            <path d="m23.43 9.0906l-10.772 7.4804c-1.3398 0.93041-2.932 1.429-4.5632 1.429h-3.0946c-1.1046 0-2 0.89543-2 2v8c0 1.1046 0.89543 2 2 2h3.0946c1.6312 0 3.2234 0.49862 4.5632 1.429l10.772 7.4804c0.66311 0.46049 1.5704-0.014053 1.5704-0.82137v-28.176c0-0.80732-0.90729-1.2819-1.5704-0.82137z" />
        </g>
    </svg>
);

export const IconFileVideo: React.SFC = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="currentColor"
            strokeLinejoin="round"
            strokeMiterlimit="10"
        >
            <path
                d="m6 3h36c1.6569 0 3 1.3431 3 3v36c0 1.6569-1.3431 3-3 3h-36c-1.6569 0-3-1.3431-3-3v-36c0-1.6569 1.3431-3 3-3z"
                strokeLinecap="round"
            />
            <line x1="45" x2="3" y1="16" y2="16" strokeLinecap="round" />
            <line x1="38" x2="45" y1="16" y2="9" strokeLinecap="round" />
            <line x1="30" x2="43" y1="16" y2="3" />
            <line x1="22" x2="35" y1="16" y2="3" strokeLinecap="round" />
            <line x1="14" x2="27" y1="16" y2="3" strokeLinecap="round" />
            <line x1="6" x2="19" y1="16" y2="3" strokeLinecap="round" />
            <line x1="3" x2="11" y1="11" y2="3" strokeLinecap="round" />
            <polygon points="21 23.5 30 30 21 36.5" strokeLinecap="round" />
        </g>
    </svg>
);

export const IconFrown = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="#FC5A5A" strokeWidth="2" fill="none" fillRule="evenodd">
            <path d="M7.714 7v2M15.714 7v2" />
            <path d="M4 17c5.333-4 10.667-4 16 0" strokeLinecap="square" />
        </g>
    </svg>
);

export const IconHelp = (props: IconSizeProps) => {
    const height = props.height || "24";
    const width = props.width || "24";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill="currentColor" fillRule="evenodd">
                <path d="M8 8.614C8.02 6.36 9.73 5.019 11.847 5c2.195 0 4.002 1.205 4.002 3.497 0 3.245-3.225 2.662-3.225 4.43v2.04h-1.38v-2.06c0-2.817 3.167-1.826 3.167-4.449 0-1.457-1.088-2.117-2.486-2.117-1.36 0-2.448.796-2.468 2.273H8zm4.935 8.063V18.6h-1.943v-1.923h1.943z" />
                <path d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
            </g>
        </svg>
    );
};

export const IconLinkedin = () => (
    <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.063 15.927H5.77V7.795H3.063v8.132zm2.883-10.64a1.385 1.385 0 0 0-.422-1.008c-.273-.266-.637-.398-1.09-.398-.453 0-.822.132-1.107.398a1.318 1.318 0 0 0-.428 1.008c0 .398.139.732.416 1.002.277.27.639.404 1.084.404h.012c.46 0 .832-.135 1.113-.404.281-.27.422-.604.422-1.002zm4.02 3.654v.037h-.024l.023-.037zm0 0V7.795H7.257c.024.515.024 3.226 0 8.132h2.707v-4.546c0-.297.028-.516.082-.657.118-.273.293-.506.528-.697.234-.191.523-.287.867-.287.906 0 1.36.613 1.36 1.84v4.347h2.706v-4.664c0-1.203-.285-2.113-.855-2.73-.57-.617-1.324-.926-2.262-.926-1.048 0-1.856.445-2.426 1.334zm8.32-4.709v11.25c0 .93-.33 1.725-.99 2.385a3.25 3.25 0 0 1-2.385.99H3.66a3.25 3.25 0 0 1-2.385-.99 3.25 3.25 0 0 1-.99-2.385V4.232c0-.93.33-1.724.99-2.385A3.25 3.25 0 0 1 3.66.857h11.25c.93 0 1.724.33 2.384.99.66.66.99 1.455.99 2.385z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export const IconLoading = (props: IconSizeProps) => {
    const height = props.height || "40";
    const width = props.width || "40";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0"
                y="0"
                width="100"
                height="100"
                fill="none"
                className="bk"
            />
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(0 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(30 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.08333333333333333s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(60 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.16666666666666666s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(90 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.25s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(120 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.3333333333333333s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(150 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.4166666666666667s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(180 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.5s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(210 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.5833333333333334s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(240 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.6666666666666666s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(270 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.75s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(300 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.8333333333333334s"
                    repeatCount="indefinite"
                />
            </rect>
            <rect
                x="46.5"
                y="40"
                width="7"
                height="20"
                rx="5"
                ry="5"
                fill="#666666"
                transform="rotate(330 50 50) translate(0 -30)"
            >
                {" "}
                <animate
                    attributeName="opacity"
                    from="1"
                    to="0"
                    dur="1s"
                    begin="0.9166666666666666s"
                    repeatCount="indefinite"
                />
            </rect>
        </svg>
    );
};

export const IconLogoMark = (props: IconSizeProps) => {
    const height = props.height || "40";
    const width = props.width || "40";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 80 80"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.943 52.362c-3.267-10.13-2.393-20.926 2.46-30.399C9.256 12.49 17.508 5.473 27.638 2.206 48.55-4.54 71.05 6.99 77.793 27.901l-17.9 5.773c-3.56-11.04-15.441-17.128-26.483-13.567a20.902 20.902 0 0 0-12.268 10.431 20.908 20.908 0 0 0-1.298 16.051l-17.9 5.773"
                fill="#A6D3F4"
            />
            <path
                d="M39.482 79.999c-6.116-.053-12.18-1.532-17.782-4.401-9.474-4.853-16.49-13.105-19.757-23.236l17.9-5.773a20.908 20.908 0 0 0 10.432 12.269 20.908 20.908 0 0 0 16.052 1.298 20.902 20.902 0 0 0 12.267-10.432 20.902 20.902 0 0 0 1.3-16.05l17.9-5.773c3.267 10.13 2.394 20.926-2.46 30.399C70.481 67.774 62.23 74.79 52.1 78.058a39.953 39.953 0 0 1-12.617 1.94"
                fill="#E35AFC"
            />
        </svg>
    );
};

export const IconLogoHorizontal = (props: IconSizeProps) => {
    const height = props.height || "30";
    const width = props.width || "115";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 115 30"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M104.345 16.142l6.064-1.98c-.811-1.74-2.075-2.45-3.996-1.823-1.839.6-2.35 2.103-2.068 3.803m10.372 2.841c.172.074.25.28.165.447-1.02 1.99-2.55 3.122-4.666 3.812-4.472 1.461-7.715-1.032-8.88-4.599-1.147-3.512-.21-7.614 4.18-9.047 4.857-1.587 7.413 1.404 8.542 4.861.103.315.158.587.188.775a.323.323 0 0 1-.22.36l-8.938 2.919c.757 1.574 2.158 2.331 4.106 1.695 1.351-.442 2.183-.949 2.805-2.062a.328.328 0 0 1 .415-.148l2.303.987M66.86 20.663c.125 0 .328-.02.506-.04.193-.022.36.129.36.322v2.248a.323.323 0 0 1-.266.32c-.465.082-1.444.239-2.187.239-1.703 0-3.031-.578-3.031-3.089V4.832c0-.157.092-.256.268-.32l2.756-.897c.2-.035.382.118.382.32V19.71c0 .663.433.952 1.212.952M79.48 16.478c0-2.309-1.04-4.301-3.637-4.301-2.598 0-3.637 1.992-3.637 4.3 0 2.31 1.04 4.302 3.637 4.302 2.598 0 3.637-1.992 3.637-4.301m3.723 0c0 3.983-3.001 7.274-7.36 7.274s-7.36-3.29-7.36-7.274c0-3.983 3.001-7.273 7.36-7.273s7.36 3.29 7.36 7.273M91.661 20.577c-2.31 0-3.406-1.79-3.406-4.157 0-2.338 1.097-4.214 3.406-4.214 2.28 0 3.32 1.847 3.32 4.214 0 2.396-1.04 4.157-3.32 4.157m8.055.046c-.179.02-.382.04-.506.04-.651 0-.837-.205-.882-.659V3.936a.325.325 0 0 0-.382-.32l-2.843.926c-.158.06-.267.162-.267.32v5.93c-1.01-1.213-2.511-1.703-4.07-1.703-3.81 0-5.975 3.435-5.975 7.331 0 3.897 2.165 7.332 5.975 7.332 1.53 0 3.002-.404 4.07-1.703h.001c.498 1.347 1.774 1.703 3.102 1.703.744 0 1.406-.157 1.87-.24a.323.323 0 0 0 .267-.319v-2.247a.324.324 0 0 0-.36-.323M50.043 16.142l6.063-1.98c-.81-1.74-2.075-2.45-3.996-1.823-1.838.6-2.35 2.103-2.067 3.803m10.372 2.841c.172.074.25.28.164.447-1.02 1.99-2.55 3.122-4.665 3.812-4.473 1.461-7.716-1.032-8.88-4.599-1.148-3.512-.21-7.614 4.18-9.047 4.856-1.587 7.412 1.404 8.541 4.861.103.315.159.587.189.775a.323.323 0 0 1-.22.36l-8.938 2.919c.757 1.574 2.158 2.331 4.106 1.695 1.35-.442 2.182-.949 2.805-2.062a.328.328 0 0 1 .414-.148l2.304.987M45.359 12.665l1.374-2.296c-.008 0 .091-.252-.088-.382-.807-.585-2.024-.812-2.856-.812-1.183 0-2.396.548-3.377 1.992V9.702a.325.325 0 0 0-.325-.324H37.39a.325.325 0 0 0-.325.324v13.436c0 .18.145.325.325.325h2.67c.179 0 .324-.145.324-.325V16.94c0-2.511 1.328-4.503 3.262-4.503.563 0 .944.068 1.285.284.043.028.305.13.429-.056"
                fill="currentColor"
            />
            <path
                d="M.653 17.607A13.312 13.312 0 0 1 1.48 7.385 13.312 13.312 0 0 1 9.293.742c7.032-2.268 14.597 1.608 16.865 8.64l-6.02 1.94c-1.196-3.712-5.191-5.758-8.904-4.561a7.028 7.028 0 0 0-4.125 3.507 7.03 7.03 0 0 0-.437 5.397L.653 17.607"
                fill="#A6D3F4"
            />
            <path
                d="M13.276 26.9a13.341 13.341 0 0 1-5.98-1.48 13.311 13.311 0 0 1-6.643-7.813l6.02-1.942a7.03 7.03 0 0 0 3.507 4.126 7.03 7.03 0 0 0 5.397.436 7.028 7.028 0 0 0 4.125-3.507 7.028 7.028 0 0 0 .437-5.397l6.019-1.942a13.31 13.31 0 0 1-.827 10.222 13.312 13.312 0 0 1-7.813 6.644 13.434 13.434 0 0 1-4.242.652"
                fill="#E35AFC"
            />
        </svg>
    );
};

export const IconLogoVertical = (props: IconSizeProps) => {
    const height = props.height || "79";
    const width = props.width || "64";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 259 200"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M82.39 64.39c-4.017-12.524-2.943-25.87 3.02-37.582 5.965-11.712 16.107-20.386 28.558-24.425 25.702-8.34 53.353 5.913 61.642 31.766l-22 7.136c-4.376-13.65-18.978-21.175-32.548-16.772-6.573 2.132-11.928 6.712-15.078 12.896-3.148 6.183-3.715 13.23-1.596 19.843l-22 7.137"
                fill="#A6D3F4"
            />
            <path
                d="M128.087 98.535c-7.517-.066-14.97-1.893-21.855-5.44C94.59 87.098 85.966 76.9 81.952 64.38l22-7.136c2.12 6.61 6.673 11.995 12.82 15.163 6.147 3.166 13.154 3.736 19.727 1.604 6.572-2.13 11.928-6.71 15.076-12.892 3.15-6.18 3.716-13.226 1.596-19.837l22-7.134c4.016 12.52 2.943 25.864-3.022 37.57-5.965 11.71-16.106 20.38-28.557 24.42-5.087 1.65-10.312 2.445-15.506 2.4"
                fill="#E35AFC"
            />
            <path
                d="M223.248 174.228l20.24-6.526c-2.705-5.73-6.926-8.07-13.34-6.003-6.135 1.976-7.842 6.93-6.9 12.528m34.624 9.362c.573.242.833.925.55 1.472-3.406 6.557-8.516 10.286-15.575 12.562-14.93 4.813-25.755-3.403-29.644-15.155-3.828-11.573-.7-25.088 13.955-29.812 16.21-5.226 24.743 4.63 28.512 16.02.343 1.036.53 1.93.63 2.553.084.522-.228 1.02-.736 1.184l-29.836 9.62c2.528 5.187 7.204 7.682 13.708 5.585 4.508-1.455 7.284-3.127 9.362-6.795.276-.486.865-.71 1.383-.49l7.692 3.255M180.85 189.39c-7.664 0-11.305-5.983-11.305-13.895 0-7.814 3.64-14.083 11.305-14.083 7.57 0 11.017 6.173 11.017 14.083 0 8.007-3.448 13.894-11.017 13.894m26.734.153c-.59.068-1.266.134-1.678.134-2.16 0-2.78-.686-2.926-2.202V133.77c0-.678-.61-1.19-1.27-1.07l-9.436 3.094c-.523.202-.886.543-.886 1.068v19.822c-3.352-4.052-8.335-5.693-13.51-5.693-12.643 0-19.83 11.482-19.83 24.505 0 13.025 7.187 24.505 19.83 24.505 5.08 0 9.965-1.35 13.51-5.692l.004.002c1.654 4.5 5.887 5.69 10.296 5.69 2.468 0 4.665-.523 6.207-.8.515-.09.885-.54.885-1.067v-7.512c0-.646-.556-1.153-1.196-1.077M140.833 175.61c0-7.743-3.445-14.423-12.052-14.423-8.608 0-12.05 6.68-12.05 14.422 0 7.742 3.442 14.422 12.05 14.422s12.053-6.68 12.053-14.423m12.338 0c0 13.357-9.946 24.39-24.39 24.39-14.443 0-24.39-11.033-24.39-24.39 0-13.358 9.947-24.39 24.39-24.39 14.444 0 24.39 11.032 24.39 24.39M99.512 189.678c.42 0 1.107-.066 1.71-.135.65-.074 1.217.43 1.217 1.078v7.514c0 .526-.378.976-.902 1.067-1.57.277-4.878.8-7.39.8-5.757 0-10.246-1.93-10.246-10.322v-52.91c0-.527.312-.857.904-1.07l9.318-2.998c.672-.12 1.29.394 1.29 1.07v52.724c0 2.22 1.465 3.184 4.098 3.184M42.76 174.228L63 167.702c-2.706-5.73-6.927-8.07-13.338-6.003-6.136 1.976-7.844 6.93-6.902 12.528m34.624 9.362c.573.242.833.925.55 1.472-3.407 6.557-8.515 10.286-15.574 12.562-14.93 4.813-25.755-3.403-29.644-15.155-3.83-11.573-.7-25.088 13.955-29.812 16.212-5.226 24.743 4.63 28.512 16.02.342 1.036.53 1.93.63 2.553.084.522-.227 1.02-.736 1.184l-29.835 9.62c2.528 5.187 7.205 7.682 13.707 5.585 4.51-1.455 7.285-3.127 9.364-6.795.275-.486.865-.71 1.384-.49l7.69 3.255M27.56 162.895l4.566-7.68c-.025-.005.305-.846-.29-1.28-2.682-1.957-6.727-2.715-9.49-2.715-3.933 0-7.96 1.833-11.22 6.663v-4.9c0-.6-.484-1.087-1.08-1.087H1.08c-.597 0-1.08.486-1.08 1.087v44.955c0 .6.483 1.086 1.08 1.086h8.87c.595 0 1.08-.487 1.08-1.086v-20.74c0-8.402 4.41-15.065 10.836-15.065 1.87 0 3.138.227 4.27.95.145.094 1.015.433 1.425-.188"
                fill="#fff"
            />
        </svg>
    );
};

export const IconMapMarker = () => (
    <svg
        width="16"
        height="21"
        viewBox="0 0 16 21"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            transform="translate(1 1)"
            stroke="#3F30A3"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M13.636 6.818A6.818 6.818 0 0 0 6.49.008C3.028.17.178 3.014.008 6.476a6.812 6.812 0 0 0 4.362 6.7c.408.157.721.492.836.914L6.818 20l1.612-5.91c.114-.42.423-.756.83-.912a6.812 6.812 0 0 0 4.376-6.36z" />
            <circle cx="6.818" cy="6.818" r="3.182" />
        </g>
    </svg>
);

export const IconMegaPhone = () => (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.963 8.199V2.177c0-.344-.244-1.26-1.12-1.26-.249 0-.497.093-.7.276l-2.977 2.68c-1.495 1.344-3.373 2.085-5.286 2.085H3.157C1.92 5.958.917 7.087.917 8.48v3.781c0 1.393 1.003 2.521 2.24 2.521l-.016 1.26c0 1.567.324 3.047.895 4.37.181.421.578.672.994.672H8.75c.912 0 1.46-1.175.907-1.991a5.434 5.434 0 0 1-.761-4.31h.983c1.913 0 3.79.74 5.286 2.085l2.977 2.68c.199.178.445.276.7.276.872 0 1.12-.897 1.12-1.26V12.54c.667-.437 1.12-1.24 1.12-2.171 0-.93-.453-1.734-1.12-2.171ZM8.751 19.823l-3.707-.001a9.382 9.382 0 0 1-.783-3.761l.016-1.26v-.02h3.479c-.081.422-.134.844-.134 1.26 0 1.39.396 2.71 1.129 3.782ZM3.157 13.52c-.617 0-1.12-.566-1.12-1.26V8.478c0-.695.503-1.26 1.12-1.26H9.88v6.302H3.157Zm15.688 5a.217.217 0 0 1-.01.035l-2.97-2.673c-1.399-1.26-3.095-2.041-4.865-2.278v-6.47c1.77-.237 3.466-1.02 4.866-2.278l2.972-2.675.002.002s.003-.002.003-.006l.002 16.342Z"
            fill="#fff"
        />
    </svg>
);

export const IconMessageRead = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M7.545 1v4.364a1.09 1.09 0 0 1-1.09 1.09H3.182" />
            <path d="M3.182 13.545v-7.09L7.545 1h14.182c.603 0 1.091.488 1.091 1.09V13M8.09 8.09h9.82M8.09 10.818h9.82M23.364 25H2.636A1.636 1.636 0 0 1 1 23.364V13l24 10.364c0 .903-.733 1.636-1.636 1.636zM25 23.364v-10.91L13 17.91M1 13l2.182-2.727M25 12.455l-2.182-2.182" />
        </g>
    </svg>
);

export const IconMessageUnread = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 29 23"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M26.714 22H2.286C1.58 22 1 21.427 1 20.727V2.273C1 1.573 1.58 1 2.286 1h24.428C27.42 1 28 1.573 28 2.273v18.454c0 .7-.58 1.273-1.286 1.273z"
                strokeLinejoin="round"
            />
            <path d="M1 1l12.15 11.474c.77.7 1.93.7 2.636 0L28 1M1 22l11-10M28 22L17 12" />
        </g>
    </svg>
);

export const IconMessageReply = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 26 25"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.708 11.364c-.036 1.09 0 3.818 0 3.818L1.536 8.09l8.191-6.86v3.587c6 0 14.718 1.237 14.718 19.091 0 0 1.154-12.545-14.737-12.545z"
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IconMessageForward = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 26 25"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.292 11.364c.036 1.09 0 3.818 0 3.818l8.172-7.091-8.191-6.86v3.587c-6 0-14.718 1.237-14.718 19.091 0 0-1.154-12.545 14.737-12.545z"
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IconPhone = (props: {
    style?: any;
    width?: number;
    height?: number;
}) => {
    const height = props.height || 22;
    const width = props.height || 22;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            xmlns="http://www.w3.org/2000/svg"
            style={props.style}
        >
            <g
                stroke="#3F30A3"
                fill="none"
                fillRule="evenodd"
                strokeLinejoin="round"
            >
                <path d="M20.245 9.014c.96-2.232.376-4.832-1.375-6.516-.38-.365-.662-.632-.662-.632a2.014 2.014 0 0 0-2.849 0l-1.237 1.237a2.014 2.014 0 0 0 0 2.848l.403.403c.967.967 1.347 2.388.954 3.697-.925 3.088-3.43 4.542-5.321 5.216a3.751 3.751 0 0 1-3.77-.752l-.437-.393a2.014 2.014 0 0 0-2.848 0L1.866 15.36a2.014 2.014 0 0 0 0 2.849l.665.665c1.733 1.733 4.365 2.248 6.594 1.23 2.156-.986 4.537-2.712 6.706-4.88 1.999-2 3.546-4.19 4.414-6.209zM6.778 15.222L3 19M18.778 2.778L15 6.556" />
            </g>
        </svg>
    );
};

export const IconRibbon = () => (
    <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
    >
        <circle
            fill="none"
            stroke={lightGreen}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="24"
            cy="16"
            r="9"
        />
        <path
            fill="none"
            stroke={lightGreen}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M37.78 16c0 1.164-1.687 2.09-1.973 3.164-.297 1.111.691 2.755.128 3.728-.57.986-2.494.949-3.294 1.749-.8.8-.763 2.724-1.75 3.294-.972.563-2.616-.425-3.727-.128-1.073.286-2 1.973-3.164 1.973-1.164 0-2.09-1.687-3.164-1.973-1.111-.297-2.755.691-3.728.128-.986-.57-.949-2.494-1.749-3.294-.8-.8-2.724-.763-3.294-1.75-.563-.972.425-2.616.128-3.727-.286-1.073-1.973-2-1.973-3.164 0-1.164 1.687-2.09 1.973-3.164.297-1.111-.691-2.755-.128-3.728.57-.986 2.494-.949 3.294-1.749.8-.8.763-2.724 1.75-3.294.972-.563 2.616.425 3.727.128 1.073-.286 2-1.973 3.164-1.973 1.164 0 2.09 1.687 3.164 1.973 1.111.297 2.755-.691 3.728-.128.986.57.949 2.494 1.749 3.294.8.8 2.724.763 3.294 1.75.563.972-.425 2.616-.128 3.727.286 1.073 1.973 2 1.973 3.164z"
        />
        <path
            fill="none"
            stroke={lightGreen}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M15 25s-4.782 6.474-7.154 16.923l4.616-3.077 2.307 5.385S17.923 32.14 21 29M32 26s5.782 5.474 8.154 15.923l-4.616-3.077-2.307 5.385S30.077 32.14 27 29"
        />
        <circle
            fill="none"
            stroke={lightGreen}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="24"
            cy="16"
            r="4.727"
        />
    </svg>
);

export const IconSearch = () => (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
        <g
            transform="translate(1 1)"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="5.6" cy="5.6" r="5.6" />
            <path d="M10.28 9.12l5.44 5.44c.16.16.16.4 0 .56l-.56.56c-.16.16-.4.16-.56 0l-5.48-5.4" />
        </g>
    </svg>
);

export const IconSiteUser = () => (
    <svg
        width="43"
        height="49"
        viewBox="0 0 43 49"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M15 27c-3.25-.083-7-1-7-1V14C8 6.82 13.82 1 21 1s13 5.82 13 13v12s-4.167.75-7 1" />
            <path d="M9 13.727C9 20.355 14.373 29 21 29s12-8.645 12-15.273c0 0-7.273-1.272-10.91-6.545C19.637 14.272 9 13.727 9 13.727z" />
            <path d="M27.004 27s-.333 4.75 5 5.278c5.333.528 10 2.99 10 13.722 0 0-7.504 2-21.004 2-13.167 0-20-2-20-2 0-10.167 4.667-12.5 10-13s5-5 5-5M18 48c-3.167-2.583-6-15-6-15M24 48c4.875-4.75 7-15 7-15" />
            <path d="M23 34c0-1.105-.895-2-2-2s-2 .895-2 2c0 1.033.785 1.872 1.79 1.98L19.067 40 21 47l2-7-1.783-4.022c1-.11 1.783-.948 1.783-1.978zM32 43h4" />
        </g>
    </svg>
);

interface IconSortProps {
    direction?: "desc" | "asc";
}

export const IconSort = (props: IconSortProps) => {
    return (
        <svg width="9" height="13" xmlns="http://www.w3.org/2000/svg">
            {(!props.direction || props.direction === "desc") && (
                <path
                    d="M8.83300781,7.85724432 C8.94433649,7.97419566 9,8.11268859 9,8.27272727 C9,8.43276595 8.94433649,8.57125888 8.83300781,8.68821023 L4.89550781,12.8245739 C4.78417913,12.9415252 4.65234451,13 4.5,13 C4.34765549,13 4.21582087,12.9415252 4.10449219,12.8245739 L0.166992187,8.68821023 C0.0556635059,8.57125888 0,8.43276595 0,8.27272727 C0,8.11268859 0.0556635059,7.97419566 0.166992187,7.85724432 C0.278320869,7.74029298 0.410155488,7.68181818 0.5625,7.68181818 L8.4375,7.68181818 C8.58984451,7.68181818 8.72167913,7.74029298 8.83300781,7.85724432 Z"
                    fill="currentColor"
                />
            )}
            {(!props.direction || props.direction === "asc") && (
                <path
                    d="M8.83300781,4.31178977 C8.94433649,4.42874112 9,4.56723405 9,4.72727273 C9,4.88731141 8.94433649,5.02580434 8.83300781,5.14275568 C8.72167913,5.25970702 8.58984451,5.31818182 8.4375,5.31818182 L0.5625,5.31818182 C0.410155488,5.31818182 0.278320869,5.25970702 0.166992187,5.14275568 C0.0556635059,5.02580434 0,4.88731141 0,4.72727273 C0,4.56723405 0.0556635059,4.42874112 0.166992187,4.31178977 L4.10449219,0.175426136 C4.21582087,0.058474794 4.34765549,0 4.5,0 C4.65234451,0 4.78417913,0.058474794 4.89550781,0.175426136 L8.83300781,4.31178977 Z"
                    fill="currentColor"
                />
            )}
        </svg>
    );
};

export const IconTwitter = () => (
    <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.286 6.506c-.438.195-.91.328-1.418.398.531-.312.894-.77 1.09-1.371a4.894 4.894 0 0 1-1.57.598c-.477-.516-1.075-.774-1.794-.774-.68 0-1.26.24-1.74.72-.48.481-.72 1.061-.72 1.741 0 .227.019.414.058.563a6.967 6.967 0 0 1-2.836-.762 6.976 6.976 0 0 1-2.25-1.817c-.227.391-.34.805-.34 1.243 0 .89.356 1.574 1.067 2.05-.368-.007-.758-.109-1.172-.304v.023c0 .586.195 1.108.586 1.565.39.457.87.74 1.441.85a2.286 2.286 0 0 1-.598.093 3.3 3.3 0 0 1-.457-.047c.164.492.455.899.873 1.219.418.32.893.484 1.424.492a4.863 4.863 0 0 1-3.058 1.055c-.203 0-.399-.012-.586-.035a6.903 6.903 0 0 0 3.773 1.101 7.17 7.17 0 0 0 2.461-.416c.766-.277 1.422-.648 1.969-1.113.547-.465 1.017-1 1.412-1.606A7.075 7.075 0 0 0 14.067 8.1c0-.14-.004-.246-.012-.316a4.783 4.783 0 0 0 1.23-1.277zm3-2.274v11.25c0 .93-.33 1.725-.99 2.385a3.25 3.25 0 0 1-2.385.99H3.66a3.25 3.25 0 0 1-2.385-.99 3.25 3.25 0 0 1-.99-2.385V4.232c0-.93.33-1.724.99-2.385A3.25 3.25 0 0 1 3.66.857h11.25c.93 0 1.724.33 2.384.99.66.66.99 1.455.99 2.385z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
interface SvgProps {
    fill?: any;
}
export const IconCheckmark = (props: SvgProps) => (
    <svg
        width="19"
        height="19"
        viewBox="0 0 24 28"
        fill={props.fill}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24 14c0 6.625-5.375 12-12 12s-12-5.375-12-12 5.375-12 12-12 12 5.375 12 12z"
            fill={props.fill}
        />
    </svg>
);

export const IconCheckmarkEmpty = (props: SvgProps) => (
    <svg
        width="19"
        height="19"
        viewBox="0 0 24 24"
        fill={props.fill}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 1c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM12 21c-5 0-9-4-9-9s4-9 9-9c5 0 9 4 9 9s-4 9-9 9z"
            fill={props.fill}
        />
    </svg>
);

export const IconSun = (props: SvgProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="#3F30A3"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        >
            <circle cx="24" cy="24" r="11.5" />
            <line x1="41" x2="44" y1="24" y2="24" strokeLinecap="round" />
            <line x1="41" x2="45" y1="24" y2="24" strokeLinecap="round" />
            <line x1="3" x2="6" y1="24" y2="24" strokeLinecap="round" />
            <line x1="3" x2="7" y1="24" y2="24" strokeLinecap="round" />
            <line x1="24" x2="24" y1="41" y2="44" strokeLinecap="round" />
            <line x1="24" x2="24" y1="41" y2="45" strokeLinecap="round" />
            <line x1="24" x2="24" y1="3" y2="6" strokeLinecap="round" />
            <line x1="24" x2="24" y1="3" y2="7" strokeLinecap="round" />
            <line
                x1="35.8"
                x2="38.4"
                y1="35.8"
                y2="38.4"
                strokeLinecap="round"
            />
            <line x1="35.8" x2="39" y1="35.8" y2="39" strokeLinecap="round" />
            <line x1="9" x2="11.6" y1="9" y2="11.6" strokeLinecap="round" />
            <line x1="9" x2="12.2" y1="9" y2="12.2" strokeLinecap="round" />
            <line
                x1="12.2"
                x2="9.6"
                y1="35.8"
                y2="38.4"
                strokeLinecap="round"
            />
            <line x1="12.2" x2="9" y1="35.8" y2="39" strokeLinecap="round" />
            <line x1="39" x2="36.4" y1="9" y2="11.6" strokeLinecap="round" />
            <line x1="39" x2="35.8" y1="9" y2="12.2" strokeLinecap="round" />
        </g>
    </svg>
);

export const IconMoon = (props: SvgProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" stroke="#3F30A3" strokeMiterlimit="10" strokeWidth="2">
            <path
                d="m21 26.5c-3.7-3.7-4.9-8.8-3.6-13.5-2.3 0.6-4.5 1.8-6.3 3.6-5.5 5.5-5.5 14.3 0 19.8s14.3 5.5 19.8 0c1.8-1.8 3-4 3.6-6.3-4.7 1.3-9.9 0.1-13.5-3.6z"
                strokeLinejoin="round"
            />
            <polygon points="25.5 8.9 26.6 11 28.9 11.4 27.2 13.1 27.6 15.4 25.5 14.3 23.4 15.4 23.8 13.1 22.1 11.4 24.4 11" />
            <polygon points="38.5 6.8 39.3 8.3 41 8.6 39.8 9.8 40 11.5 38.5 10.7 37 11.5 37.3 9.8 36 8.6 37.7 8.3" />
            <polygon points="32.5 22.8 33.3 24.3 35 24.6 33.8 25.8 34 27.5 32.5 26.7 31 27.5 31.3 25.8 30 24.6 31.7 24.3" />
        </g>
    </svg>
);

export const IconSunrise = (props: SvgProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="#3F30A3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        >
            <path d="m10 24c0-7.7 6.3-14 14-14s14 6.3 14 14" />
            <line x1="3" x2="45" y1="25" y2="25" />
            <line x1="7" x2="40" y1="30" y2="30" />
            <line x1="15" x2="32" y1="35" y2="35" />
        </g>
    </svg>
);

export const IconComment = (props: SvgProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="#3F30A3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        >
            <path d="m40 19c3 2.8 4.9 6.9 4.9 11.4 0 2.3-0.5 4.5-1.4 6.5 0 0-0.8 4.2 3.5 8.5 0 0-7.9 1.7-10.7-1-2.1 1-4.4 1.6-6.9 1.6-5.1 0-9.7-2.5-12.5-6.3" />
            <path d="m1 35.6s8.3 1.7 11.3-1c2.2 1.1 4.6 1.7 7.3 1.7 9 0 16.4-7.4 16.4-16.4 0-9.1-7.3-16.4-16.4-16.4-9 0-16.4 7.4-16.4 16.4 0 2.4 0.5 4.8 1.5 6.8 0 0 0.9 4.4-3.7 8.9z" />
        </g>
    </svg>
);

export const IconMail = (props: SvgProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="#3F30A3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        >
            <path
                d="m43 42h-38c-1.1 0-2-0.9-2-2v-29c0-1.1 0.9-2 2-2h38c1.1 0 2 0.9 2 2v29c0 1.1-0.9 2-2 2z"
                strokeLinejoin="round"
            />
            <path d="M3,9l18.9,18c1.2,1.1,3,1.1,4.1,0L45,9" />
            <line x1="3" x2="21" y1="42" y2="26" />
            <line x1="45" x2="27" y1="42" y2="26" />
        </g>
    </svg>
);

export const IconPhone2 = (props: SvgProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            fill="none"
            stroke="#3F30A3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        >
            <path d="m44.302 19.032c2.1602-5.022 0.84557-10.872-3.0951-14.661-0.85515-0.82227-1.4887-1.4231-1.4887-1.4231-1.7699-1.7699-4.6394-1.7699-6.4093 0l-2.7831 2.7831c-1.7699 1.7699-1.7699 4.6394 0 6.4093l0.9069 0.9069c2.1744 2.1744 3.0298 5.3714 2.1465 8.3168-2.0834 6.9475-7.7183 10.221-11.974 11.736-2.9237 1.0408-6.179 0.38816-8.4836-1.6902l-0.98075-0.88448c-1.7699-1.7699-4.6394-1.7699-6.4093 0l-2.7831 2.7831c-1.7699 1.7699-1.7699 4.6394-2e-7 6.4093l1.4967 1.4967c3.8994 3.8994 9.8204 5.0579 14.836 2.7659 4.8504-2.2165 10.208-6.1003 15.088-10.98 4.4976-4.4976 7.9783-9.4253 9.9322-13.968z" />
            <line x1="14" x2="5.5" y1="33" y2="41.5" />
            <line x1="41" x2="32.5" y1="5" y2="13.5" />
        </g>
    </svg>
);
